<template>
  <div class="modalWrapper">
    <div class="modalBlock" :class="modalBlockType">
      <div v-if="scanned.success" class="title">
        {{ $t(`home.sng.headline_success`) }}
      </div>
      <div class="content">
        <video
          v-if="scanned.success"
          autoplay
          muted
          src="~@/assets/green_checkmark.webm"
          playsinline
        />
        <video
          v-if="!scanned.success"
          autoplay
          muted
          src="~@/assets/red_cross.webm"
          playsinline
        />
        <div class="title" v-if="!scanned.success">
          {{ $t(`home.sng.headline_fail`) }}
        </div>
        <div v-if="!scanned.success">{{ $t(`home.sng.subline_fail`) }}</div>
      </div>
      <div v-if="scanned.success" class="ScanAndGoProductContainer">
        <ProductList
          :products="[scanned.product]"
          :limit="1"
          passive
          :noprices="true"
        ></ProductList>
      </div>
      <div v-if="!scanned.success" class="actions">
        <div class="btn" @click="close">
          {{ $t(`home.sng.continue`) }}
        </div>
      </div>
    </div>
    <div class="modalBackdrop" @click="close"></div>
  </div>
</template>
<script>
import ProductList from "@/components/menu/ProductList";

export default {
  components: { ProductList },
  props: {
    scanned: Object
  },
  data() {
    return {
      timer: null
    };
  },
  computed: {
    modalBlockType() {
      if (this.scanned.success) {
        return "modalBlock-isScanSuccessful";
      } else {
        return "modalBlock-isScanFailed";
      }
    }
  },
  methods: {
    timerClose() {
      this.timer = null;
      this.close();
    },
    close() {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.$emit("close");
    }
  },
  created() {
    this.timer = setTimeout(
      this.timerClose,
      this.scanned.success ? 2000 : 4000
    );
  },
  beforeDestroy() {
    if (this.timer) {
      clearTimeout(this.timer);
    }
  }
};
</script>
<style lang="scss" scoped>
.modalWrapper {
  height: 100vh;
  width: 100vw;
  background: rgba(0, 0, 0, 0.4);
  position: fixed;
  z-index: 1500;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}
.modalBlock {
  position: fixed;
  z-index: 1600;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: 550px auto auto auto;
  width: 750px;
  height: 440px;
  background: #fff 0% 0% no-repeat padding-box;
  box-shadow: 4px 4px 25px #00000033;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  text-align: center;
  padding: 50px;
  color: black;
  justify-content: space-around;
}
.modalBlock-isScanSuccessful {
  background: var(
    --component_modals_common_productAttributes_modalBlock_background
  );
  height: 580px;
  padding-top: 90px;
}
.modalBlock-isScanFailed {
  height: 440px;
}
.modalBackdrop {
  height: 100vh;
  width: 100vw;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  z-index: 1550;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  margin: auto;
}

.actions {
  display: flex;
  justify-content: space-around;
}
.btn {
  width: 210px;
  height: 70px;
  background: #f39a00;
  border: var(--app_button-outlined_border-width) solid #f39a00;
  border-radius: 33px;
  color: #fff;
  font-size: 20px;
  letter-spacing: 1.84px;
  font-family: var(--app_font-family_regular);
  display: flex;
  justify-content: center;
  align-items: center;
}

.content {
  flex-grow: 2;
  font-family: var(--app_font-family_regular);
  font-size: 22px;
}
.title {
  font-size: 30px;
  font-family: var(--app_font-family_bold);
  text-transform: uppercase;
  margin-bottom: 20px;
}

video {
  margin: 20px;
}
</style>
<style lang="scss">
.ScanAndGoProductContainer {
  height: 330px;
  margin: auto;
  overflow: hidden;
  width: 300px;
}
</style>
